<script>
  import Toggler from '@/components/Toggler';

  export default {
    components: {
      Toggler,
    },

    data: () => ({
      two_steps: false,
    }),
  };
</script>

<template>
  <main class="account-audit">
    <header class="account-audit__header">
      <h1 class="sidebar__title">Dados da conta</h1>

      <button
        class="account-audit__action"
        >
        Alterar senha
      </button>

      <button
        class="account-audit__action account-audit__action--2fa"
        >
        Token 2FA
        <Toggler
          :value="two_steps"
          class="account-audit__action-toggler"
          />
      </button>
    </header>

    <h2 class="account-audit__title">Dispositivos cadastrados</h2>

    <table>
      <thead>
        <tr>
          <th>Data / Hora</th>
          <th>IP</th>
          <th>Localização</th>
          <th>Navegador</th>
          <th>S.O</th>
        </tr>
      </thead>
        <tbody>
          <tr :key="i" v-for="i in 6">
            <td>02/05/29 - 08:24:45</td>
            <td>9034858404.23</td>
            <td>São Paulo</td>
            <td>Chrome</td>
            <td>Windows</td>
          </tr>

          <h2 class="account-audit__title">Últimos acessos</h2>

          <tr :key="i + 10" v-for="i in 3">
            <td>02/05/29 - 08:24:45</td>
            <td>9034858404.23</td>
            <td>São Paulo</td>
            <td>Chrome</td>
            <td>Windows</td>
          </tr>
        </tbody>
    </table>
  </main>
</template>

<style lang="scss">
  .account-audit {
    &__header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    &__action {
      color: #FFF;
      display: flex;
      line-height: 1;
      min-width: 176px;
      padding: 14px 16px;
      border-radius: 4px;
      align-items: center;
      align-self: flex-start;
      justify-content: center;
      border: solid 1px #ffffff;

      &-toggler {
        margin-left: 24px;
      }

      &--2fa {
        border-color: #3e388b;
        background-color: #3e388b;

        &:hover {
          background-color: #322c76 !important;
        }
      }

      &:hover {
        background-color: rgba(#FFF, 0.1);
      }

      &:first-of-type {
        margin-left: auto;
      }

      &:not(:first-of-type) {
        margin-left: 48px;
      }
    }

    &__title {
      margin: 56px 0 32px;
      letter-spacing: .32px;
      color: rgba(#FFF, .8);
    }

    table {
      width: 100%;
      text-align: left;
      color: #b2b8c5;
      border-spacing: 0;

      th {
        font-weight: 400;
        padding-bottom: 32px;
      }

      td {
        font-size: 13px;
        padding-bottom: 16px;
      }
    }
  }
</style>
